import React, { useState } from "react"
import axios from "axios"
import { useForm } from "react-hook-form"
import { Button, TextField } from "@mui/material"
import { Box } from "@mui/system"

import { FlexColumnContainer } from "components/AllHelpComponents"
import DialogComponent from "components/DialogComponent"
import { LoadingOverlay } from "components/LoadingOverlay"
import { baseURL } from "constants/api"
import { creditCardInitialData } from "constants/constants"
import { useStateContext } from "contexts/userContext"
import { useTranslation } from "react-i18next"

export const CardPayForm = ({ routePathname, services, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)
  const { restaurant_id } = useStateContext()
  const { t } = useTranslation()

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const { register, handleSubmit, setValue } = useForm()

  const handleFillForm = () => {
    setValue("cardNumber", creditCardInitialData.cardNumber, { shouldDirty: true, shouldTouch: true, shouldValidate: true })
    setValue("expiryDate", creditCardInitialData.expiryDate, { shouldDirty: true, shouldTouch: true, shouldValidate: true })
    setValue("cvv", creditCardInitialData.cvv, { shouldDirty: true, shouldTouch: true, shouldValidate: true })
    setValue("email", creditCardInitialData.email, { shouldDirty: true, shouldTouch: true, shouldValidate: true })
  }

  async function payCreditCard(payData) {
    try {
      setIsSubmitting(true)
      await axios.post(baseURL + routePathname, {
        services,
        payData,
        restaurant_id,
      })
      setIsSubmitting(false)

      if (typeof onSuccess === "function") {
        onSuccess()
      }

      console.log('Запрос "payment/execute" успешно выполнен')
    } catch (error) {
      setIsSubmitting(false)
      console.error('Ошибка при выполнении запроса "payment/execute":', error)
      return
    }
  }

  return (
    <>
      {isSubmitting ? <LoadingOverlay /> : null}

      <FlexColumnContainer>
        <Box component="form" onSubmit={handleSubmit(payCreditCard)}>
          <TextField
            {...register("cardNumber", {
              required: "Card number is required",
            })}
            label={t("Card number")}
            sx={{ width: "100%", mb: 2 }}
            InputLabelProps={{ shrink: true }}
          />

          <Box sx={{ display: "flex", gap: "16px", pb: 2 }}>
            <TextField
              {...register("expiryDate", {
                required: "Expiry date is required",
              })}
              label={t("Expiry date")}
              sx={{ flex: 1, mr: 2 }}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              {...register("cvv", { required: "Cvv code is required" })}
              label={t("Cvv code")}
              sx={{ flex: 1 }}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <TextField
            {...register("email", { required: "Email is required" })}
            label={t("Email")}
            sx={{ width: "100%", mb: 2 }}
            InputLabelProps={{ shrink: true }}
          />

          <Button type="submit" variant="contained" sx={{ mr: 2 }}>
            {t("Submit")}
          </Button>
          <Button variant="outlined" onClick={handleFillForm}>
            {t("Fill Form")}
          </Button>
        </Box>
      </FlexColumnContainer>

      <DialogComponent
        dialogTitle="Success"
        text="Order successfully created!"
        buttonRight="Ok"
        open={dialogOpen}
        onClose={handleCloseDialog}
      />
    </>
  )
}
